<template>
    <section class="main">
        <HeadSectionMain :data="head" class="fill-height"/>
        <OurProducts />
        <infoComponent class="dabble-bg"/>
        <template v-for="(product, i) in listProducts" :key="i">
            <productComponent :data="product"
                              :src-img="'page-main/'"
                              :class="[
                                  i%2 && 'reverse color-white' || 'color-gray',
                                  // i === 0 && 'first',
                                  // (i === listProducts.length - 1) && 'last'
                              ]"
            />
        </template>
    </section>
</template>

<script>
export default {
    name: 'HomePage',
    data() {
        return {
            jsonFile: ''
        }
    },
    components: {},
    computed:{
        head(){
            return this.jsonFile?.head
        },
        listProducts() {
            return this.jsonFile?.list_products
        }
    },
    mounted() {
    },
    created() {
        this.jsonFile = require('../../pages/main-page.json')
    }
}
</script>
<style lang="scss" scoped>
.color-white {
    background: white;
}
.dabble-bg {
    background: white;
    padding: 90px 0;
//    position: relative;
//    z-index: 1;
//    &:before,
//    &:after {
//        content: '';
//        display: block;
//        position: absolute;
//        width: 100%;
//        height: 50%;
//        top: 0;
//        left: 0;
//        z-index: -1;
//    }
//    &:before {
//        background: #F0F2F4;
//    }
//    &:after {
//        top: 50%;
//        background: #F9F9F9;
//    }
}
</style>